import * as React from 'react';

function HurtsWorstIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
        fill="#E7501A"
      />
      <path
        d="M14.487 20.048c-.022 0-.043 0-.067-.003l-4.617-.377a.81.81 0 0 1 .135-1.613l1.87.153-1.377-1.05a.808.808 0 1 1 .983-1.285l3.563 2.726a.807.807 0 0 1-.49 1.449ZM25.543 20.047a.807.807 0 0 1-.49-1.449l3.566-2.723a.807.807 0 1 1 .98 1.285l-1.376 1.05 1.869-.153a.81.81 0 0 1 .132 1.613l-4.616.377h-.065ZM19.994 31.22c-1.692 0-2.51-1.327-3.17-2.396-.622-1.01-1.042-1.63-1.794-1.63-1.163 0-2.074 1.414-2.882 2.944a.806.806 0 1 1-1.427-.754c1.045-1.974 2.292-3.803 4.31-3.803 1.69 0 2.51 1.328 3.17 2.397.621 1.01 1.041 1.63 1.793 1.63.751 0 1.171-.62 1.794-1.63.657-1.067 1.478-2.397 3.17-2.397 2.025 0 3.336 1.958 4.352 3.876a.808.808 0 1 1-1.43.756c-.744-1.403-1.75-3.016-2.925-3.016-.752 0-1.172.62-1.794 1.63-.657 1.066-1.476 2.394-3.167 2.394Z"
        fill="#2B2523"
      />
    </svg>
  );
}

export default HurtsWorstIcon;
